import { Typography } from "@mui/material";
import classes from "./index.module.scss";

export default function Content({ answer }) {
  return <Typography className={classes.text}>{answer}</Typography>;
}
